import React, {useRef, useState} from 'react';
import {useMiniGame} from "./useCharacterPackage";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import TablePage from "../../../pages/tablePage/TablePage";
import MiniGameEditModal from "../MiniGameEditModal";

const MiniGameManager = () => {
    const {data: miniGame, isLoading: isMiniGameLoading, error: miniGameError} = useMiniGame();
    const [rowData, setRowData] = useState({});

    const refreshRef = useRef(null);

    const columns = [
        {
            title: '인덱스',
            dataIndex: 'index',
            key: 'index',
        },
        {
            title: 'CardInfo 인덱스',
            dataIndex: 'cardInfo',
            key: 'cardInfo',
        },
        {
            title: 'GameInfo 인덱스',
            dataIndex: 'info',
            key: 'info',
        },
        {
            title: 'Mission 인덱스',
            dataIndex: 'mission',
            key: 'mission',
        },
        {
            title: 'Reward 인덱스',
            dataIndex: 'reward',
            key: 'reward',
        },
        {
            title: '메모',
            dataIndex: 'memo',
            key: 'memo',
        }

    ];

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        localData: miniGame,
        modal: MiniGameEditModal,
        buttonText: '신규 미니게임 추가',
    }

    const isLoading = isMiniGameLoading;
    const error = miniGameError;
    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;
    return (
        <div>
            <TablePage {...props}/>
        </div>
    );
};

export default MiniGameManager;